import { Component, OnInit, OnDestroy, ViewChild, Injector } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { UsuariosService } from './usuarios.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import * as ptLocale from 'date-fns/locale/pt';
import { LoadingService } from '../../../util/loader.service';
const swal = require('sweetalert');


@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit, OnDestroy {
  blur = false;
  teste: number = 0;
  testeSelected: any[] = [];
  selectCheck;
  selected: any[] = [];
  isSelected;
  filterState: boolean = true;
  rows: Object[];
  registroSelecao: any[] = [];
  parametroConsulta: string;
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    conta: true,
  };
  mesagensGrid = {
    'emptyMessage': 'Nenhum dado para exibir',
    'totalMessage': 'Total de registros',
    'selectedMessage': 'Selecionado'
  };
  acoesBottoes: boolean = true;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  sortDir: string = "";
  sortProp: string = "";

  ngOnDestroy(): void {

  }

  constructor(public service: UsuariosService, public injector: Injector, private route: ActivatedRoute, private router: Router, public loader: LoadingService) {
    this.reloadTable();
  }

  filtro(event) {
    if (event.keyCode == 13) {
      this.page.descricao = this.parametroConsulta;
      this.page.offset = 0;
      this.reloadTable();
    }
  }

  clearReload() {
    this.page.descricao = "";
    this.parametroConsulta = "";
    this.page.offset = 0;
    this.reloadTable();
  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }

  reloadTable() {
    this.loader.show("body");
    this.service.obterTodos(this.page, this.sortDir, this.sortProp)
      .subscribe((itens) => {
        this.loader.hide("body");
        this.page.count = itens.count;
        this.rows = itens.rows;
      });

  }


  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.id_usuarios == codigo) {
        x = true;
      }
    });
    return x;
  }

  linkEdit() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.router.navigate(['/fidel/usuario/editar/' + this.registroSelecao[0].id_usuarios]);
    }
  }


  linkAlterarSenha() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      if (!this.registroSelecao[0].possui_conta) {
        swal('Atenção', 'Este usuário não possui uma conta cadastrada..', 'warning');

      } else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            "data": JSON.stringify(this.registroSelecao[0]),
          },
          skipLocationChange: true
        };
        this.router.navigate(['/fidel/usuario/alterarsenha'], navigationExtras);
      }
    }
  }
  ngOnInit() {
  }

  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);

    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].codigo == item[0].codigo) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }

  // inativarRegistros() {
  //   swal({
  //     title: 'Atenção',
  //     text: 'Você deseja alterar o status desse registro?',
  //     type: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#DD6B55',
  //     confirmButtonText: 'Sim',
  //     cancelButtonText: 'Não',
  //     closeOnConfirm: false
  //   }, () => {
  //     var ids = [];
  //     this.registroSelecao.forEach(function (s) {
  //       ids.push(s.codigo);
  //     });
  //     this.service.inativarOuAtivarUsuarios(ids)
  //       .subscribe(result => {
  //         if (result.success) {
  //           this.reloadTable();
  //           this.limparSelecionados();
  //           swal('Atenção', 'Ação realizada com sucesso.', 'success');
  //         }
  //       });
  //   });
  // }

  informacoesAdicionais() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.router.navigate(['/fidel/pessoa/detalhes/' + this.registroSelecao[0].codigoColaborador + '/4']);
    }
  }

  onFilterChange(eve: any) {
    this.limparSelecionados();
    this.page.conta = eve;
    this.reloadTable();
  }

  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;
  }




  /*
    reenviarSenha() {
      if (this.registroSelecao.length > 1) {
        swal('Atenção', 'Selecione apenas um registro.', 'warning');
      } else {
        this.loader.show("body");
        this.service.reenviaSenha(this.registroSelecao[0].login).subscribe(result => {
          if (result.success) {
            this.reloadTable();
            this.limparSelecionados();
            this.loader.hide("body");
            swal('Atenção', 'Nova senha enviada por email.', 'success');
          } else {
            this.loader.hide("body");
          }
        });
      }
    }*/


  onSort(event) {
    this.sortDir = event.sorts[0].dir;
    this.sortProp = event.sorts[0].prop;
    this.page.offset = 0;
    this.reloadTable();
  }
}
